import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#6E6E7D",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.127",
      d: "M10.847 4.43h-.48v-.48z",
      style: {"stroke":"color(display-p3 .4296 .4296 .4915)","stroke-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#A7A7B1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.127",
      d: "M7.983 2.552h.023a.04.04 0 0 1 .02.01.04.04 0 0 1 .01.02l.001.023v2.407l.004.09.001.023a1.765 1.765 0 0 0 1.622 1.627l.023.002.094.003h2.409l.022.002a.04.04 0 0 1 .02.01.04.04 0 0 1 .01.02l.001.023v5.391a1.24 1.24 0 0 1-1.16 1.237l-.095.002H4.995l-.118-.005a1.24 1.24 0 0 1-1.12-1.156l-.001-.095V3.792a1.24 1.24 0 0 1 1.16-1.237l.095-.002z",
      style: {"stroke":"color(display-p3 .6543 .6543 .6951)","stroke-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }